(function () {
  'use strict';

  class ProductModelViewerManager {
    constructor(container, options) {
      if (!container) {
        throw new Error('ProductModelViewerManager: container is required');
      }

      this.container = container;
      this.options = options || {};
      this.modelViewerUIs = [];
      this.modelViewerElements = [];
      this.onPlayCallback = this.options.onPlay || null;
      this.onPauseCallback = this.options.onPause || null;

      this.setupShopifyXR = () => {
        if (!window.ShopifyXR) {
          document.addEventListener('shopify_xr_initialized', this.setupShopifyXR);
          return;
        }

        document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
          window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
          modelJSON.remove();
        });
        window.ShopifyXR.setupXRElements();
      };

      this.setupFromFeature = (errors) => {
        this.setup(errors);
      };

      this._init();
    }

    _init() {
      Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
          onLoad: this.setupShopifyXR,
        },
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: this.setupFromFeature,
        },
      ]);
    }

    setup(errors) {
      if (errors) return;

      this.cleanup();

      const modelViewers = this.container.querySelectorAll('model-viewer');
      const closeElements = this.container.querySelectorAll('[id^="DeferredPosterClose-"]');

      modelViewers.forEach((modelViewer, index) => {
        if (!modelViewer.hasAttribute('loaded')) {
          modelViewer.setAttribute('loaded', '');

          const onPlay = () => { this.handlePlay(modelViewer, index); };
          const onPause = () => { this.handlePause(modelViewer, index); };

          modelViewer._playHandler = onPlay;
          modelViewer._pauseHandler = onPause;

          modelViewer.addEventListener('shopify_model_viewer_ui_toggle_play', onPlay);
          modelViewer.addEventListener('shopify_model_viewer_ui_toggle_pause', onPause);

          this.modelViewerUIs.push(new Shopify.ModelViewerUI(modelViewer));
          this.modelViewerElements.push(modelViewer);
        }
      });

      closeElements.forEach((closeElement, index) => {
        const onClick = (event) => { this.handleClose(event, index); };
        closeElement._clickHandler = onClick;
        closeElement.addEventListener('click', onClick);
      });

      this.closeElements = closeElements;
    }

    handlePlay(modelViewer, index) {
      modelViewer.setAttribute('playing', '');

      if (this.closeElements && this.closeElements[index]) {
        this.closeElements[index].removeAttribute('hidden');
      }

      if (this.onPlayCallback) {
        this.onPlayCallback(modelViewer, index);
      }
    }

    handlePause(modelViewer, index) {
      modelViewer.removeAttribute('playing');

      if (this.closeElements && this.closeElements[index]) {
        this.closeElements[index].setAttribute('hidden', '');
      }

      if (this.onPauseCallback) {
        this.onPauseCallback(modelViewer, index);
      }
    }

    handleClose(event, index) {
      event.preventDefault();
      event.stopPropagation();

      if (this.modelViewerUIs && this.modelViewerUIs[index]) {
        this.modelViewerUIs[index].pause();
      }
    }

    pauseAll() {
      if (this.modelViewerElements && this.modelViewerElements.length > 0) {
        this.modelViewerElements.forEach((modelViewer, index) => {
          if (modelViewer.hasAttribute('loaded') && modelViewer.hasAttribute('playing')) {
            if (this.modelViewerUIs && this.modelViewerUIs[index]) {
              this.modelViewerUIs[index].pause();
            }
          }
        });
      }
    }

    cleanup() {
      if (this.modelViewerElements) {
        this.modelViewerElements.forEach((modelViewer) => {
          if (modelViewer._playHandler) {
            modelViewer.removeEventListener('shopify_model_viewer_ui_toggle_play', modelViewer._playHandler);
            delete modelViewer._playHandler;
          }
          if (modelViewer._pauseHandler) {
            modelViewer.removeEventListener('shopify_model_viewer_ui_toggle_pause', modelViewer._pauseHandler);
            delete modelViewer._pauseHandler;
          }
        });
        this.modelViewerElements = [];
      }

      if (this.closeElements) {
        this.closeElements.forEach((closeElement) => {
          if (closeElement._clickHandler) {
            closeElement.removeEventListener('click', closeElement._clickHandler);
            delete closeElement._clickHandler;
          }
        });
        this.closeElements = null;
      }

      this.modelViewerUIs = [];
    }

    destroy() {
      this.cleanup();
      this.container = null;
      this.onPlayCallback = null;
      this.onPauseCallback = null;
    }
  }

  window.Universe.ProductModelViewerManager = ProductModelViewerManager;
})();
